import React, { FC } from 'react'
import { Image } from '@/atoms/Image'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import {
  GHeadingSM,
  GParagraphLG,
  GParagraphXL,
  GParagraphMD,
  GResponsiveText,
  GTitleLG,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import {
  getDavidIntroText,
  getDavidOutroText,
  getDavidPrizeText,
} from '@/views/PreSales/PreSalesGiveawayView/config/giveaway-prizes/projects/david'

export const DavidDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-3 grid gap-16">
      <div>
        <GResponsiveText
          color="giveaway-text-subtle-light"
          className="mb-6 pt-3"
          MobileTextComponent={GParagraphLG}
          DesktopTextComponent={GParagraphXL}
        >
          <Translate i18nKey="giveawayDavidExplainerv2" t={t}>
            <i>DAVID</i> is a major animated feature film from Slingshot Productions, Sunrise Productions, and Angel —
            created for audiences worldwide. Warrior, poet, shepherd, and king, David&apos;s story is one of courage,
            faith, and freedom. Beyond the giant&apos;s shadow, a young shepherd boy rises to inspire a nation.
          </Translate>
        </GResponsiveText>
        <GResponsiveText
          color="giveaway-text-subtle-light"
          className="mb-6 pt-3"
          MobileTextComponent={GParagraphLG}
          DesktopTextComponent={GParagraphXL}
        >
          {t(
            'giveawayDavidExplainer2',
            'This Christmas, experience the ultimate underdog story on the big screen. Only in theaters, December 19, 2025. Pre-order today and be automatically entered into the David Bible Tour Giveaway.',
          )}
        </GResponsiveText>
      </div>
      <div>
        <GResponsiveText
          color="giveaway-text-primary-dark"
          className="mb-3"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GHeadingSM}
        >
          {t('DavidGrandPrize', 'David Christmas Tour Giveaway')}
        </GResponsiveText>
        <div className="py-3">
          <a
            href="https://www.inspirationtravel.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="relative overflow-hidden rounded-lg md:max-w-56"
          >
            <div className="aspect-h-6 aspect-w-16 relative max-w-[361px] overflow-hidden rounded-[10px] md:max-w-[530px]">
              <Image
                src="https://images.angelstudios.com/image/upload/v1763499759/david/David_Giveaway_ImageAds_Updates_InspirationTravel3.webp"
                alt={'Win the trip of a lifetime with Inspiration Travel'}
                fill
                className="object-fill"
              />
            </div>
          </a>
        </div>
        {getDavidIntroText(t)}
        {getDavidPrizeText(t)}
        {getDavidOutroText(t)}
        <Translate i18nKey={'EstimatedValueDavidV2'} t={t}>
          <GResponsiveText
            color="giveaway-text-subtle-light"
            className={'py-8 !font-bold'}
            MobileTextComponent={GParagraphMD}
            DesktopTextComponent={GParagraphLG}
          >
            Estimated value: $60,000
          </GResponsiveText>
        </Translate>
      </div>
    </div>
  )
}
